import {ExceptionError} from '../exception'
import {Request} from '../request'
import {IPageOption} from '../../interface/paging/paging'
import {IApiResponse, IApiListResponse} from '../../interface/api-response/api-response'
import {API_PATH} from '../../constants/api-path'
import {IAttribute, IAttributeCreate, IAttributeUpdate} from '../../interface/attribute'
import {IBaseAttributeGroup} from '../../interface/tag'

export class GetAttributeService extends Request {
  async request(options?: IPageOption) {
    try {
      const {data} = await this.client
        .get<IApiListResponse<IAttribute[]>>(API_PATH.ATTRIBUTE_GROUP, {
          params: options,
        })
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class GetAttributeFilterService extends Request {
  async request(options?: IPageOption, filter?: any) {
    try {
      const {data} = await this.client
        .post<IApiListResponse<IAttribute[]>>(
          `${API_PATH.ATTRIBUTE_GROUP}/filter`,
          {
            ...filter,
          },
          {
            params: options,
          }
        )
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class CreateAttributeService extends Request {
  async request(payload: IAttributeCreate) {
    const {data} = await this.client.post<IAttribute>(API_PATH.ATTRIBUTE_GROUP, payload)
    try {
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class UpdateAttributeService extends Request {
  async request(payload: IAttributeUpdate) {
    try {
      const {data} = await this.client.patch<IAttribute>(API_PATH.ATTRIBUTE_GROUP, payload)
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class DeleteAttributeService extends Request {
  async request(id: string) {
    try {
      const {data} = await this.client
        .delete<IApiResponse<any>>(`${API_PATH.ATTRIBUTE_GROUP}/${id}`)
        .then((d) => d.data)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class GetAttributeByPlantService extends Request {
  async request(id: string, getOnlyActive?: boolean) {
    try {
      const {data} = await this.client
        .get<IApiResponse<IAttribute[]>>(
          `${API_PATH.ATTRIBUTE_GROUP}/get-by-plant-id/${id}?getOnlyActive=${getOnlyActive}`
        )
        .then((d) => d.data)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class GetAttributeByTagTypeIdService extends Request {
  async request(id: string) {
    try {
      const {data} = await this.client
        .get<IApiResponse<IBaseAttributeGroup[]>>(
          `${API_PATH.ATTRIBUTE_GROUP}/get-by-tag-type-id/${id}`
        )
        .then((d) => d.data)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class GetAttributeLogService extends Request {
  async request(params: any) {
    try {
      const {data} = await this.client
        .get<IApiResponse<any>>(`${API_PATH.ATTRIBUTE_GROUP}/get-log/${params.id}`, {params})
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
